<template>
  <main class="acquisition-management pa-2 pa-md-4">
    <header class="px-2 pt-3">
      <h1 class="text-h6 font-weight-bold">Studiovergleich</h1>
      <p class="text-caption mt-1 mb-0">Kontakte und zugehörige Einträge · alle Studios · gewählter Zeitraum</p>
    </header>
    <center-acquisition-statistics all-studios :range="datePickerRange" />
  </main>
</template>

<script>
import CenterAcquisitionStatistics from "./CenterAcquisitionStatistics.vue"

export default {
  name: "homeDashboardAcquisitionManagement",
  components: { CenterAcquisitionStatistics },
  props: { datePickerRange: { type: Array, default: () => [] } },
}
</script>

<style scoped>
.acquisition-management { min-height: 100vh; background: #212121; color: #f1f5f9; }
.acquisition-management header p, .acquisition-management .text-overline { color: #b8c4d4; }
</style>
